import __request__ from 'routing/request';
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface stringMap {
    readonly [_key: string]: string;
}
interface SecurityLakeRequestImpl {
    readonly security_lake_queue_name: string;
    readonly aws_region: string;
    readonly aws_access_key: string;
    readonly aws_secret_key: unknown;
}
interface SecurityLakeCreateInputRequest {
    readonly security_lake_queue_name: string;
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly aws_region: string;
    readonly aws_access_key: string;
    readonly name: string;
    readonly aws_secret_key: unknown;
    readonly store_full_message: boolean;
    readonly enable_throttling: boolean;
    readonly polling_interval: number;
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: SecurityLakeRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.awssecuritylake.api.SecurityLakeResource/awssecuritylake/checkCredentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get all available AWS regions
 */
export function getAWSRegions(): Promise<stringMap> {
    return __request__('GET', '/plugins/org.graylog.enterprise.integrations.awssecuritylake.api.SecurityLakeResource/awssecuritylake/getawsregions', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Security Lake input
 */
export function create(JSONbody: SecurityLakeCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.awssecuritylake.api.SecurityLakeResource/awssecuritylake/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
